module.exports = __webpack_public_path__ + "static/media/suggestion-development.a87bb831.png";